import React, { useState } from "react";
import {
  Typography,
  Box,
  IconButton,
  Avatar,
  AppBar,
  Toolbar,
  Tabs,
  Tab,
} from "@mui/material";
import { Notifications, CalendarToday } from "@mui/icons-material";
import AppHeaderBar from "../../components/AppBar/appBar";
import EmailMarketing from "./AdminVendorAddBanners";
import PushNotification from "./PushNotification";
import BadgesRibbion from "./AdminCoupons";
import Sliders from "./Sliders";
import SpecialPrices from "./Sliders";
import CampaignForm from "./CreateCapign";
import AdminAddBanner from "./AdminAddBanner";
import AdminVendorAddBanners from "./AdminVendorAddBanners";
import AdminCoupons from "./AdminCoupons";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const MarketandPromotions = ({ onBackScreenName }) => {
  const [mainTabValue, setMainTabValue] = useState(0);
  const [subTabValue, setSubTabValue] = useState(0);

  const handleMainTabChange = (event, newValue) => {
    setMainTabValue(newValue);
  };

  const handleSubTabChange = (event, newValue) => {
    setSubTabValue(newValue);
  };

  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        p: 2,
        bgcolor: "#EEF2FF",
      }}
    >
      <AppHeaderBar
        title={"Marketing and Promotions"}
        onBackScreenName={handleScreeName}
      />

      <Tabs
        value={mainTabValue}
        onChange={handleMainTabChange}
        sx={{
          // backgroundColor: "white",
          borderBottom: "1px solid #ddd",
          color: "black",
        }}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Slider" sx={{ textTransform: "none" }} />
        <Tab label="Add Banners" sx={{ textTransform: "none" }} />
        <Tab label="Vendor Add Banners" sx={{ textTransform: "none" }} />
        <Tab label="Coupons" sx={{ textTransform: "none" }} />
        <Tab label="Push Notification" sx={{ textTransform: "none" }} />
      </Tabs>

      <TabPanel value={mainTabValue} index={0}>
        <Sliders />
      </TabPanel>
      <TabPanel value={mainTabValue} index={1}>
        <AdminAddBanner />
      </TabPanel>
      <TabPanel value={mainTabValue} index={2}>
        <AdminVendorAddBanners />
      </TabPanel>
      <TabPanel value={mainTabValue} index={3}>
        <AdminCoupons />
      </TabPanel>
      <TabPanel value={mainTabValue} index={4}>
        <PushNotification />
      </TabPanel>
    </Box>
  );
};

export default MarketandPromotions;
